const productBasePaths: Record<string, string> = {
  nl: '/producten',
  de: '/produkte',
  en: '/products',
  fr: '/produits',
  da: '/products',
  it: '/products',
  es: '/products',
  pl: '/products',
  pt: '/products',
  cs: '/products',
};

const cartPaths: Record<string, string> = {
  nl: '/winkelwagen',
  de: '/warenkorb',
  en: '/cart',
  fr: '/panier',
};

const checkoutPaths: Record<string, string> = {
  nl: '/checkout',
  de: '/kasse',
  en: '/checkout',
  fr: '/paiement',
};

const orderPaths: Record<string, string> = {
  nl: '/bestelling',
  de: '/bestellung',
  en: '/order',
  fr: '/commande',
};

const orderTrackingPaths: Record<string, string> = {
  nl: '/bestelling-volgen',
  de: '/bestellung-verfolgen',
  en: '/track-order',
  fr: '/suivre-commande',
};

const knowledgeBasePaths: Record<string, string> = {
  nl: '/kennisbank',
  de: '/wissensdatenbank',
  en: '/knowledge-base',
  fr: '/base-de-connaissances',
};

const categorySegments: Record<string, string> = {
  nl: 'categorie',
  de: 'kategorie',
  en: 'category',
  fr: 'categorie',
  da: 'category',
  it: 'category',
  es: 'category',
  pl: 'category',
  pt: 'category',
  cs: 'category',
};

export function productsPath(locale: string, query?: Record<string, string | number | undefined>) {
  const basePath = productBasePaths[locale] || productBasePaths.nl;
  const params = new URLSearchParams();
  let categorySlug: string | undefined;

  if (query) {
    Object.entries(query).forEach(([key, value]) => {
      if (value === undefined || value === '') return;
      // Categorie krijgt een eigen pad (/producten/categorie/<slug>) in plaats
      // van een query-param: betere landingspagina's voor SEO en Ads.
      if (key === 'category' && String(value) !== 'all') {
        categorySlug = String(value);
        return;
      }
      if (key === 'category') return;
      params.set(key, String(value));
    });
  }

  const path = categorySlug
    ? `${basePath}/${categorySegments[locale] || categorySegments.nl}/${encodeURIComponent(categorySlug)}`
    : basePath;
  const queryString = params.toString();
  return queryString ? `${path}?${queryString}` : path;
}

export function productPath(locale: string, slug: string) {
  return `${productsPath(locale)}/${slug}`;
}

/** De kennisbank staat in vier talen op een eigen adres; de rest leest Engels. */
export function kennisbankPath(locale: string) {
  return knowledgeBasePaths[locale] || knowledgeBasePaths.en;
}

export function kennisbankArtikelPath(locale: string, slug: string) {
  return `${kennisbankPath(locale)}/${slug}`;
}

export function localizedPath(locale: string, path: string) {
  const safeLocale = productBasePaths[locale] ? locale : 'nl';
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `/${safeLocale}${normalizedPath}`;
}

export function localizedProductsPath(locale: string, query?: Record<string, string | number | undefined>) {
  return localizedPath(locale, productsPath(locale, query));
}

export function localizedProductPath(locale: string, slug: string) {
  return localizedPath(locale, productPath(locale, slug));
}

export function absoluteLocalizedProductUrl(locale: string, slug: string, baseUrl = 'https://www.printen.eu') {
  return `${baseUrl}${localizedProductPath(locale, slug)}`;
}

export function cartPath(locale: string) {
  return cartPaths[locale] || (productBasePaths[locale] ? cartPaths.en : cartPaths.nl);
}

export function checkoutPath(locale: string) {
  return checkoutPaths[locale] || (productBasePaths[locale] ? checkoutPaths.en : checkoutPaths.nl);
}

export function orderPath(locale: string, orderNumber: string) {
  const basePath = orderPaths[locale] || (productBasePaths[locale] ? orderPaths.en : orderPaths.nl);
  return `${basePath}/${orderNumber}`;
}

export function orderTrackingPath(locale: string) {
  return orderTrackingPaths[locale] || (productBasePaths[locale] ? orderTrackingPaths.en : orderTrackingPaths.nl);
}
